import { schema } from 'normalizr';
import { referralFormSchema } from './referralFormSchema';

export const formFieldSchema = new schema.Entity('formField', {
  form_id: referralFormSchema,
});
